import { User } from '@data/models/user.interface';
import * as Reducers from '@stores/reducers/Reducers';
import { Dispatch } from 'redux';

export const setUser =
  (user: Partial<User>) =>
  (dispatch: Dispatch): void => {
    dispatch({ type: Reducers.SET_USER, payload: user });
  };
